import { Modal } from 'antd';
import React from 'react';
import AssetCatalogDetail from './AssetCatalogDetail';

export type AssetCatalogModalProps = {
  visible: boolean;
  onCancel: () => void;
  title: String;
  catalogid: number;
};

const AssetCatalogDetailsModal = ({
  onCancel,
  visible,
  title,
  catalogid,
}: AssetCatalogModalProps) => {
  console.log({catalogid})
  return (
    (<Modal
      open={visible}
      onCancel={onCancel}
      width={1500}
      title={title}
      footer={null}
    >
      <AssetCatalogDetail catalogid={catalogid} isModal="true" />
    </Modal>)
  );
};

export default AssetCatalogDetailsModal;
